import { mapPermissionDtoToModel, PermissionDto, PermissionModel } from 'api/dto/Permission.dto';

export type PermissionTypesView = {
  id: string;
  permissions: PermissionModel[];
  label?: string;
};

export type PermissionTypesDto = {
  primary_feature: PermissionDto[];
  feature: PermissionDto[];
  comment_demographic: PermissionDto[];
  comment_department: PermissionDto[];
  summary_demographic: PermissionDto[];
  summary_department: PermissionDto[];
  access: PermissionDto[];
};

export type PermissionTypesModel = {
  primary_feature: PermissionModel[];
  feature: PermissionModel[];
  comment_demographic: PermissionModel[];
  comment_department: PermissionModel[];
  summary_demographic: PermissionModel[];
  summary_department: PermissionModel[];
  access: PermissionModel[];
};

export function mapPermissionTypesDtoToModel(dto: PermissionTypesDto): PermissionTypesModel {
  return {
    primary_feature: dto.primary_feature ? dto.primary_feature.map(mapPermissionDtoToModel) : [],
    feature: dto.feature ? dto.feature.map(mapPermissionDtoToModel) : [],
    comment_demographic: dto.comment_demographic
      ? dto.comment_demographic.map(mapPermissionDtoToModel)
      : [],
    comment_department: dto.comment_department
      ? dto.comment_department.map(mapPermissionDtoToModel)
      : [],
    summary_demographic: dto.summary_demographic
      ? dto.summary_demographic.map(mapPermissionDtoToModel)
      : [],
    summary_department: dto.summary_department
      ? dto.summary_department.map(mapPermissionDtoToModel)
      : [],
    access: dto.access?.map(mapPermissionDtoToModel) ?? [],
  };
}

export namespace PermissionTypesModel {
  export function getPrimaryPermissionsView(
    permissionTypesModel: PermissionTypesModel,
  ): PermissionTypesView {
    return {
      id: 'feature',
      permissions: permissionTypesModel.primary_feature,
    };
  }

  export function getPermissionTypesView(
    permissionTypesModel: PermissionTypesModel,
    isClientAdmin: boolean,
    isPulseTemplate: boolean,
  ): PermissionTypesView[] {
    const projectAccessView = {
      id: 'access',
      label: 'Survey access:',
      permissions: permissionTypesModel.access,
    };

    const featurePermissionsView = {
      id: 'feature',
      label: 'Feature',
      permissions: permissionTypesModel.feature,
    };

    const departmentSummaryPermissionsView = {
      id: 'summary-department',
      label: 'View results for:',
      permissions: permissionTypesModel.summary_department,
    };

    const demographicSummaryPermissionsView = {
      id: 'summary-demography',
      label: 'View following demographics:',
      permissions: permissionTypesModel.summary_demographic,
    };

    const departmentCommentPermissionsView = {
      id: 'comment-department',
      label: 'View comments for:',
      permissions: permissionTypesModel.comment_department,
    };

    const basePermissionsTypesView = [
      ...(isPulseTemplate ? [projectAccessView] : []),
      featurePermissionsView,
      departmentSummaryPermissionsView,
      demographicSummaryPermissionsView,
      departmentCommentPermissionsView,
    ];

    return isClientAdmin
      ? basePermissionsTypesView
      : [
          ...basePermissionsTypesView,
          {
            id: 'comment-demography',
            label: 'View comments for:',
            permissions: permissionTypesModel.comment_demographic,
          },
        ];
  }
}
